import { ITextValue } from '@/types/common';
import { getPropertyTypesForFilters } from '@/bundles/GroupFilters/consts/getPropertyTypesForFilters';

const MIXED_USE = 'Mixed Use';

export const getPropertyTypesWithMixedUseForFilters = (): ITextValue<string>[] => {
  const propertyTypes = getPropertyTypesForFilters();
  propertyTypes.push({ text: MIXED_USE, value: MIXED_USE.toLowerCase() });

  // unique array by text property
  return [...new Map(propertyTypes.map(item => [item.text, item])).values()];
}
